const moment = require('moment');

angular
  .module('promotionCodeAdd')
  .component('promotionCodeAdd', {
    template: require('./promotion-code-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$timeout', '$translate', 'AuthService', 'envService',
      function PromotionCodeAddViewController($rootScope, $scope, $resource, $route, $location, $window, $timeout, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'coupons';
        $rootScope.menu = 'promotion';
        $scope.doLogout = $rootScope.gLogout;
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $resource(`${APIURL}/admin/coupons/constraints/locations`).get().$promise
          .then((data) => {
            this.constraintsLocations = data.constraintsLocations;
          });
        $resource(`${APIURL}/admin/goods/types`).get({}, (data) => {
          this.goodsTypes = [];
          this.goodsTypes.push({ ID: 0, TYPE: 'all' });
          this.goodsTypes = this.goodsTypes.concat(data.goodsTypes);
        }, (err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        this.newcoupon = { VALID_AT: `${moment().add(30, 'days').format('YYYY-MM-DD')}`, PRICE: 15000, COUPON_VALID_DAYS: 7, NOTE: '', CODE: '', GOODS_TYPE: 'all', MAX_QUANTITY: -1, COUPON_TYPE: '00', MULTIPLE_USE_YN: 'N' };
        this.selectedUsers = [];
        this.submit = () => {
          if (!moment(this.newcoupon.VALID_AT, 'YYYY-MM-DD', true).isValid()) {
            alert($translate.instant('올바른 유효기간:만료일을 입력해주세요.(예:2016-01-01)'));
            return;
          }
          if (this.newcoupon.CODE.length < 1) {
            alert($translate.instant('CODE를 입력해주세요.'));
            return;
          }
          if (this.newcoupon.PRICE < 0) {
            alert($translate.instant('가격을 입력해주세요.'));
            return;
          }
          if (this.newcoupon.COUPON_VALID_DAYS < 1) {
            alert($translate.instant('쿠폰 유효기간을 입력해주세요.'));
            return;
          }
          if (this.newcoupon.NOTE.length < 1) {
            alert($translate.instant('발급사유를 입력해주세요.'));
            return;
          }
          if (this.newcoupon.MAX_QUANTITY_INPUT) {
            if (!Number.isInteger(parseInt(this.newcoupon.MAX_QUANTITY_INPUT, 10))) {
              alert($translate.instant('올바른 쿠폰 수량을 입력해주세요.'));
              return;
            }
            this.newcoupon.MAX_QUANTITY = parseInt(this.newcoupon.MAX_QUANTITY_INPUT, 10);
          }
          
          this.newcoupon.MULTIPLE_USE_YN = this.newcoupon.MULTIPLE_USE_YN ? 'Y' : 'N';

          if (this.newcoupon.CONSTRAINT_ID && parseInt(this.newcoupon.CONSTRAINT_ID, 10) > 0) {
            this.newcoupon.COUPON_CONSTRAINTS_IDS = [parseInt(this.newcoupon.CONSTRAINT_ID, 10)];
          }
          $resource(`${APIURL}/admin/promotion/coupons`).save(this.newcoupon).$promise
            .then(() => {
              $location.path('/promotion/code');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.openNewCouponConstraintsModal = () => {
          this.newCouponConstraints = { type: 'L', name: '', polyline: '' };
          jQuery('#modal-new-coupon-constraints').modal('show');
        };
        this.hideNewCouponConstraintsModal = () => {
          jQuery('#modal-new-coupon-constraints').modal('hide');
        };
        this.addNewCouponConstraints = () => {
          if (this.newCouponConstraints.name.length < 1) {
            alert($translate.instant('이름을 입력해주세요.'));
            return;
          }
          const pattern = /[<>()#'/|\s/g]/;
          console.log(pattern.test(this.newCouponConstraints.name));
          if (pattern.test(this.newCouponConstraints.name)) {
            alert($translate.instant('공백 및 특수문자(<, >, (, ), #, \', /, | )는 사용할 수 없습니다.'));
            return;
          }
          if (this.newCouponConstraints.polyline.length < 1) {
            alert($translate.instant('Polyline을 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/coupons/constraints/locations`).save(this.newCouponConstraints).$promise
            .then((data) => {
              this.constraintsLocations = data.constraintsLocations;
              jQuery('#modal-new-coupon-constraints').modal('hide');
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/promotion-code-add/promotion-code-add.component.js